export const prefix = 'suggpro'
export const storageVersion = 1
export const storagePrefix = prefix + '@' + storageVersion
